import { connect } from 'react-redux'

import { selectAgentsByIdIncludingArchived } from 'selectors/agents/base'

import AgentLinkView from './AgentLinkView'

const select = (state, { value }) => ({
  agent: selectAgentsByIdIncludingArchived(state)[value],
})

export default connect(select)(AgentLinkView)
